<template>
  <div class="recycle-box">
    <h3 class="left title" :title="item.title">{{ item.title }}</h3>
    <p class="left intro" v-html="item.intro"></p>
    <!-- <div class="recycle-bottom"> -->
    <div class="recycle-bottom clear">
      <!-- <el-row :gutter="20">
          <el-col :span="18" class="document-bottom-left"> -->
      <div class="recycle-bottom-right fr" @click="deleteDoc">
        <el-tooltip effect="dark" content="删除" placement="top">
          <div class="recycle-delete"></div>
        </el-tooltip>
      </div>
      <div class="recycle-bottom-left fl">
        <span>{{ item.delTime | dateformat("MM-DD HH:mm") }}</span>
        <span class="ml5">删除</span>
      </div>
      <div class="recycle-bottom-right fr" @click="recycle">
        <el-tooltip effect="dark" content="还原" placement="top">
          <div class="recyle"></div>
        </el-tooltip>
      </div>
    </div>
    <div class="recycle-checkbox">
      <el-checkbox v-model="item.ischecked"></el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
  computed: {},
  methods: {
    //撤回
    recycle() {
      this.$emit("withdrawdoc", this.item.docId);
    },
    //删除
    deleteDoc() {
      let _this = this;
      this.$confirm("此操作将永久删除该文集, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
        // center: true,
      })
        .then(() => {
          _this.$emit("deleteDoc", _this.item.docId);
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.recycle-box {
  width: 230px;
  height: 180px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(219, 227, 247, 1);
  border-radius: 4px;
  position: relative;
  padding: 16px;
  &:hover {
    cursor: pointer;
    box-shadow: 0px 0px 4px 2px #e5eaf7;
  }
  .title {
    .left();
    .rownumber(2);
    color: rgba(51, 51, 51, 1);
    font-size: 18px;
    line-height: 28px;
    height: 56px;
  }
  .intro {
    .rownumber(3);
    margin-top: 10px;
    width: 195px;
    height: 56px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
  }
  .recycle-bottom {
    margin-top: 8px;

    .recycle-bottom-left {
      .left();
      font-size: @font-size12;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
    .recycle-bottom-right {
      .cursor();
      height: 21px;
      display: flex;
      align-items: center;
      .recycle-delete {
        width: 15px;
        height: 15px;
        background-image: url(../../assets/image/document/delete.png);
        // line-height: 20px;
      }
      .recyle {
        width: 15px;
        height: 15px;
        background-image: url(../../assets/image/document/recycle.png);
        // line-height: 20px;
        margin-right: 10px;
      }
    }
  }
}

.recycle-box span {
  color: @color999;
  font-size: 12px;
}

.recycle-box .recycle-bottom-left {
  text-align: left;
}
//.recycle-box span:nth-child(2) {
//   // cursor: pointer;
// }
.recycle-box span.icon-recycle {
  color: green;
  cursor: pointer;
  font-size: 14px;
}
.recycle-box span.icon-delete {
  color: red !important;
  cursor: pointer;
  font-size: 14px;
}
//checkbox
.recycle-checkbox {
  position: absolute;
  top: 0px;
  right: 5px;
}
</style>
